/* This file is autogenerated, see readme.md for instructions */
import RefreshSvgIcon from '@bloomreach/banana-theme/icons/refresh.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const RefreshIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <RefreshSvgIcon />
    </Icon>
  );
});

RefreshIcon.displayName = 'RefreshIcon';

export default RefreshIcon;
